/* eslint-disable no-nested-ternary */
/* eslint-disable default-param-last */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import {
  Box,
  TableCell,
  TableRow,
  Tooltip,
  Button as MuiButton,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import * as Sentry from "@sentry/react";
import CustomTable from "../../../../components/common/new/Table/Table";
import { DIRECT_APPOINTMENT_COL } from "../../../../contants/table/appointment";
import Styles from "./DirectAppointment.styles";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { UHG_SEARCH_FIELDS } from "../../../../contants/formFields";
import useQueryParams from "../../../../hooks/useQueryParams";
import { isEmptyObj } from "../../../../utils/helper";
import OrganisationSearch from "../components/OrganisationSearch";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
  selectUserProfile,
} from "../../../../redux/selectors/user";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
// import SearchResultTable from "../components/SearchResultTable";
import Appointment from "../../../../services/api/appointment";
import Loader from "../../../../components/common/Loader/Loader";
import { getDirectAppointmentType } from "../../../../utils";
import Alert from "../../../../components/common/new/Alert/Alert";
import SearchResultTableSpecial from "../components/SearchResultTableSpecial";

function StudentApply() {
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const userData = useSelector(selectUserProfile);
  const { getQueryObject } = useQueryParams();
  const {
    isChapterSi,
    isRegionSi,
    isZoneSi,
    isAreaSi,
    isHelpDesk,
    isHelpDeskAdmin,
  } = useSelector(selectAllSIUsers);
  const [showTable, setShowTable] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [appointedMembers, setAppointedMembers] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({
    groupId: null,
    members: [],
    positionId: null,
    membersDetails: [],
    positionType: "",
  });
  const [payload, setPayload] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [selectedAreaLabel, setSelectedAreaLabel] = useState("");
  const isMobile = useMediaQuery("(max-width: 768px)");

  const acceptAppointmentHandler = () => {
    setOpenAlert(true);
  };

  const deleteAppointmentHandler = () => {
    setOpenDeleteAlert(true);
  };

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const toggleDeleteAlert = () => {
    setOpenDeleteAlert(false);
  };

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      return disabledOSKeys.reduce(
        (acc, key) => ({
          ...acc,
          [key]: userData[key] || "",
        }),
        {}
      );
    }
    return {};
  };

  const initializeFormValues = () => {
    const queryValues = getQueryObject();
    const formValues = isEmptyObj(queryValues)
      ? preselectOSKeys()
      : queryValues;

    return {
      [UHG_SEARCH_FIELDS.AREA]: formValues[UHG_SEARCH_FIELDS.AREA] || "",
      [UHG_SEARCH_FIELDS.ZONE]: formValues[UHG_SEARCH_FIELDS.ZONE] || "",
      [UHG_SEARCH_FIELDS.REGION]: formValues[UHG_SEARCH_FIELDS.REGION] || "",
      [UHG_SEARCH_FIELDS.CHAPTER]: formValues[UHG_SEARCH_FIELDS.CHAPTER] || "",
      [UHG_SEARCH_FIELDS.DISTRICT]:
        formValues[UHG_SEARCH_FIELDS.DISTRICT] || "",
    };
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
    // setSelectedMembers([]);
    setAppointedMembers([]);
    // setSelectedMemberData([]);
    setSelectedGroup({
      groupId: null,
      members: [],
      positionId: null,
      membersDetails: [],
      positionType: "",
    });
  };

  const getOSDepthByUserRole = (params) => {
    let result = { ...params };
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      result = Object.assign(
        result,
        disabledOSKeys.reduce((acc, key) => {
          if (userData[key]) {
            return Object.assign(acc, { [key]: userData[key] });
          }
          return acc;
        }, {})
      );
    }
    result = Object.assign(result);
    return result;
  };

  const valuesArray = Object.values(selectedAreaName);

  const getGroupData = (data) => {
    const searchData = data;

    const groupedData = [];
    searchData.forEach((item) => {
      const existingRow = groupedData.find(
        (row) =>
          row.divisionName === item.divisionName &&
          row.positionName === item.positionName &&
          row.subDivisionName === item.subDivisionName
      );

      if (existingRow) {
        existingRow.members.push(item.memberDetails);
      } else {
        groupedData.push({
          id: uuidv4(), // use to select only one row
          divisionName: item.divisionName,
          positionName: item.positionName,
          positionType: item.positionType,
          positionId: item.positionId,
          divisionId: item.divisionId,
          subDivisionId: item.subdivisionId,
          subDivisionName: item.subDivisionName,
          members: [item.memberDetails],
        });
      }
    });

    return groupedData;
  };

  const handleAppointNew = (id) => {
    const selectedRowData = searchData.find((d) => d.id === id);
    const {
      positionId,
      subDivisionId,
      divisionId,
      divisionName,
      subDivisionName,
      positionName,
    } = selectedRowData;
    const overridePosition = !!selectedGroup.members.length;

    const selectedMemberIds = selectedGroup?.members || [];

    const selectedMembersDetails = selectedGroup?.membersDetails || [];

    const divisionNameCombined = subDivisionName
      ? `${divisionName} - ${subDivisionName}`
      : divisionName;

    const updatedAppointedMembers = {
      positionId,
      selectedMembers: selectedMemberIds,
      overridePosition,
      divisionId,
      divisionName: divisionNameCombined,
      positionName,
      subDivisionId,
      selectedMembersDetails,
      valuesArray,
    };

    setAppointedMembers([updatedAppointedMembers]);
    setSelectedRow(selectedRowData);
    // setSelectedMembers(selectedRowData.members);
    setModalOpen(true);
  };

  const toggleMemberSelection = (
    memberId,
    positionId,
    groupId,
    isChecked,
    memberDetails,
    positionType
  ) => {
    const addMember = (members, id) => members.concat(id);
    const removeMember = (members, id) => members.filter((mId) => mId !== id);

    setSelectedGroup((prev) => {
      // add member to already existing group
      if (prev.groupId === groupId) {
        const updatedMembers = isChecked
          ? addMember(prev.members, memberId)
          : removeMember(prev.members, memberId);
        const updatedMemberDetails = isChecked
          ? [...prev.membersDetails, memberDetails]
          : prev.membersDetails.filter(
              (member) => member.memberId !== memberId
            );

        return {
          ...prev,
          members: updatedMembers,
          membersDetails: updatedMemberDetails,
        };
      } // add member to new group
      return {
        groupId,
        positionId,
        members: isChecked ? addMember([], memberId) : [],
        membersDetails: isChecked ? [memberDetails] : [],
        positionType,
      };
    });
  };

  const fetchData = async (params) => {
    try {
      setIsLoading(true);
      const divisionIds = "3,37";
      const subDivisionIds = "57,58";
      // const result = await Appointment.directAppointmentApplications({
      //   ...params,
      //   divisionId: divisionIds,
      //   subdivision: true,
      // });
      const result =
        await Appointment.specialGroupDirectAppointmentApplications({
          ...params,
          divisionId: divisionIds,
          subdivisionId: subDivisionIds,
          // subdivision: true,
        });
      setSearchData(getGroupData(result.data.appointments));
      setPayload(params);
      let selectedOptionLabel = "";
      let selectedAreaName = "";

      if (result.data.blockName) {
        selectedOptionLabel = "Block";
        selectedAreaName = result.data.blockName;
      } else if (result.data.districtName) {
        selectedOptionLabel = "District";
        selectedAreaName = result.data.districtName;
      } else if (result.data.chapterName) {
        selectedOptionLabel = "Chapter";
        selectedAreaName = result.data.chapterName;
      } else if (result.data.regionName) {
        selectedOptionLabel = "Region";
        selectedAreaName = result.data.regionName;
      } else if (result.data.zoneName) {
        selectedOptionLabel = "Zone";
        selectedAreaName = result.data.zoneName;
      } else if (result.data.areaName) {
        selectedOptionLabel = "Area";
        selectedAreaName = result.data.areaName;
      }

      setSelectedAreaLabel(selectedOptionLabel);
      setSelectedAreaName(selectedAreaName);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const handleRemove = async () => {
    try {
      setIsLoading(true);
      const positionid = selectedGroup.positionId;
      const memberId = selectedGroup.members ? selectedGroup.members : [];
      const positiontype = selectedGroup.positionType;

      const body = {
        memberIds: memberId,
        positionId: positionid,
        positionType: positiontype,
      };

      await Appointment.directAppointmentRemoveApplications(payload, body);
      toast.show("Removed Successfully", AlertStatus.SUCCESS);
      toggleAlert();
      setTimeout(() => {
        fetchData(payload);
        toggleAlert();
      }, 2000);
      setIsLoading(false);
      setSelectedGroup({
        groupId: null,
        members: [],
        positionId: null,
        membersDetails: [],
      });
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const positionid = selectedGroup.positionId;
      const memberId = selectedGroup.members ? selectedGroup.members : [];
      const positiontype = selectedGroup.positionType;

      const body = {
        memberIds: memberId,
        positionId: positionid,
        positionType: positiontype,
      };

      await Appointment.directAppointmentDeleteApplications(payload, body);
      toast.show("Delete Successfully", AlertStatus.SUCCESS);
      toggleDeleteAlert();
      setTimeout(() => {
        fetchData(payload);
        toggleDeleteAlert();
      }, 2000);
      setIsLoading(false);
      setSelectedGroup({
        groupId: null,
        members: [],
        positionId: null,
        membersDetails: [],
        positionType: "",
      });
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const getRows = (searchResults) => {
    let previousDivisionName = null;

    return searchResults
      .map((group, index) => {
        if (isEmptyObj(group)) {
          return null;
        }
        const isGroupSelected = selectedGroup.groupId === group.id;
        const isAnyMemberSelected = selectedGroup.members.length > 0;

        const { divisionName } = group;
        const showDivisionName = divisionName !== previousDivisionName;
        previousDivisionName = divisionName;
        return (
          <>
            {showDivisionName && (
              <TableRow key={`${divisionName}-division`}>
                <TableCell
                  colSpan={4}
                  style={{
                    background: "#cfe3ff",
                    // fontWeight: "bold",
                  }}
                >
                  {group.subDivisionName} [{divisionName}]
                </TableCell>
              </TableRow>
            )}
            <TableRow
              style={
                selectedRow === index ? { backgroundColor: "#cfe3ff" } : null
              }
              key={index}
            >
              <TableCell style={Styles.cell}>
                {/* {group.divisionName || "NA"}
                <br />
                {group.subDivisionName || "NA"} */}
              </TableCell>
              <TableCell style={Styles.cell}>
                {group.positionName || "NA"}
              </TableCell>
              <TableCell style={Styles.cell}>
                {group.members.map((member, memberIndex) => {
                  const { groupId, members } = selectedGroup;
                  const checked =
                    group.id === groupId && members.includes(member?.memberId);

                  return (
                    <Box key={memberIndex}>
                      <div>
                        <label>
                          {member ? (
                            <>
                              <Tooltip
                                title="If you want to replace or remove this member, select the checkbox"
                                placement="top"
                              >
                                <span
                                  style={{
                                    marginRight: "10px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) =>
                                      toggleMemberSelection(
                                        member?.memberId,
                                        group.positionId,
                                        group.id,
                                        e.target.checked,
                                        member,
                                        group.positionType
                                      )
                                    }
                                  />
                                </span>
                              </Tooltip>
                              {member.fullName} ({member.memberId}) (
                              {getDirectAppointmentType(group.positionType)})
                            </>
                          ) : (
                            `No ${group.positionName}`
                          )}
                        </label>
                      </div>
                    </Box>
                  );
                })}
              </TableCell>
              <TableCell style={Styles.cell}>
                <Box style={{ ...Styles.ActionBtnContainer }}>
                  <Button
                    variant="outlined"
                    style={{
                      ...Styles.applyButton,
                      marginBottom: "10px",
                    }}
                    onClick={() => handleAppointNew(group.id)}
                    label="APPOINT NEW"
                  />
                  {isGroupSelected &&
                    isAnyMemberSelected &&
                    selectedGroup.members.length === 1 && (
                      <Button
                        variant="outlined"
                        style={{
                          ...Styles.applyButton,
                          marginBottom: "10px",
                          lineHeight: "17px",
                        }}
                        onClick={acceptAppointmentHandler}
                        label="No Longer Hold Position"
                      />
                    )}
                  {isGroupSelected &&
                    isAnyMemberSelected &&
                    selectedGroup.members.length === 1 && (
                      <Button
                        variant="outlined"
                        style={{
                          ...Styles.applyButton,
                          marginBottom: "10px",
                        }}
                        onClick={deleteAppointmentHandler}
                        label="Delete"
                      />
                    )}
                </Box>
              </TableCell>
            </TableRow>
          </>
        );
      })
      .filter(Boolean);
  };

  const handleSearch = async (values, e) => {
    e.preventDefault();

    if (isChapterSi) {
      if (!values[UHG_SEARCH_FIELDS.DISTRICT]) {
        toast.show("Please select the District field", AlertStatus.ERROR);
        return;
      }
      if (!values[UHG_SEARCH_FIELDS.BLOCK]) {
        toast.show("Please select the Block field", AlertStatus.ERROR);
        return;
      }
    }

    if (isRegionSi && !values[UHG_SEARCH_FIELDS.CHAPTER]) {
      toast.show("Please select the Chapter field", AlertStatus.ERROR);
      return;
    }
    if (isZoneSi && !values[UHG_SEARCH_FIELDS.REGION]) {
      toast.show("Please select the Region field", AlertStatus.ERROR);
      return;
    }

    if (isAreaSi && !values[UHG_SEARCH_FIELDS.ZONE]) {
      toast.show("Please select the Zone field", AlertStatus.ERROR);
      return;
    }
    if (isHelpDesk && !values[UHG_SEARCH_FIELDS.AREA]) {
      toast.show("Please select the Area field", AlertStatus.ERROR);
      return;
    }
    if (isHelpDeskAdmin && !values[UHG_SEARCH_FIELDS.AREA]) {
      toast.show("Please select the Area field", AlertStatus.ERROR);
      return;
    }

    setShowTable(true);
    fetchData(getOSDepthByUserRole(values));
  };

  useEffect(() => {
    if (!modalOpen) {
      fetchData(payload);
    }
  }, [appointedMembers, payload, modalOpen]);

  return (
    <Box>
      <Box style={Styles.filters}>
        <Formik initialValues={initializeFormValues()}>
          {({ values, errors, handleChange, setFieldValue, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box style={{ marginBottom: "4px" }}>
                <OrganisationSearch
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  disabledOSKeys={disabledOSKeys}
                  // showStudentDivision
                  // showSubDivision
                />
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-start",
                  paddingTop: isMobile ? "20px" : "10px",
                  marginRight: isMobile ? "15px" : "10px",
                  paddingBottom: isMobile ? "100px" : "0px",
                }}
              >
                <MuiButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    width: isMobile ? "90%" : "auto",
                  }}
                  onClick={(e) => handleSearch(values, e)}
                >
                  Search
                </MuiButton>
              </div>
            </form>
          )}
        </Formik>
      </Box>
      {showTable && (
        <>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography component="p" color="#8C8C8C" weight={500} my={4}>
              Members Appointed For{" "}
              {selectedAreaLabel && selectedAreaName && (
                <>
                  &quot;{selectedAreaLabel}&nbsp;-&nbsp;{selectedAreaName}&quot;
                </>
              )}
            </Typography>
            <Typography
              component="div"
              color="red"
              weight={500}
              my={4}
              style={{
                fontSize: "16px",
                paddingRight: "30px",
              }}
            >
              <span style={{ display: "block" }}>
                *If you want to replace or remove the member, select the
              </span>
              <span style={{ display: "block" }}>
                checkbox or else you can appoint a new member to that position
              </span>
            </Typography>
          </Box>

          {searchData.length === 0 ? (
            <Box style={Styles.emptyContainer}>
              <h1 style={Styles.noDataMsg}>No Results</h1>
            </Box>
          ) : (
            <CustomTable
              columnCellStyle={{ textAlign: "center" }}
              scrollable
              columns={DIRECT_APPOINTMENT_COL}
              rows={getRows(searchData)}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...Styles.tableHeadCells,
              }}
            />
          )}
        </>
      )}
      {isLoading && <Loader />}
      <SearchResultTableSpecial
        open={modalOpen}
        onClose={closeModal}
        appointedMembers={appointedMembers}
        payload={payload}
      />
      <Alert open={openAlert} onClose={toggleAlert} onSubmit={handleRemove} />
      <Alert
        open={openDeleteAlert}
        onClose={toggleDeleteAlert}
        onSubmit={handleDelete}
      />
    </Box>
  );
}

export default StudentApply;
